import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';
import Limit from 'Flow2/util/Limit';

const initialState = {
        error: null,
        initialized: false,
        messages: [],
        dialog: null,
		modules: [],
        history: 0,
        limits: {},
        keys: [],
        products: [],
        version: false
};

const initStart = (state, action) => {
    return updateObject( state, { initialized: false, history: window.history.length } );
}

const initSuccess = (state, action) => {
    return updateObject( state, { initialized: true } );
}

const initFail = (state, action) => {
    console.trace();
    return updateObject( state, {
        error: 'App could not be initialized',
        initialized: false
    });
}
const appError = (state, action) => {
    return updateObject( state, {
        error: action.error
    });
}
const addMessage = (state, action) => {
    let newState = {...state};
    if(action.payload.target === 'messages' || action.payload.target === 'both') {
        let newMessages = state.messages.slice();
        newMessages.push(action.payload.message);
        newState = updateObject(newState, { 
            messages: newMessages
        });
    }
    if(action.payload.target === 'dialog' || action.payload.target === 'both') {
        newState = updateObject(newState, { 
            dialog: action.payload.message
        });
    }
    return newState;
}

const initModules = (state, action) => {
        action.obj.addEventListener('update', function(e) { console.log('update',e)});
        return updateObject(state, { initLimit: true });
    if(!state.initLimit) {
    }
    return state;
}

const moduleSuccess = (state, action) => {
	const module = action.module;
	const modules = [ ...state.modules ];
	const index = modules.indexOf(module);
	
	if(index === -1) {
		modules.push(module);
	}
	
	return updateObject( state, {
        modules: [ ...modules ]
    });
}

const moduleError = (state, action) => {
	const module = action.module;
	const modules = [ ...state.modules ];
	const index = modules.indexOf(module);
	
	if(index !== -1) {
		modules.splice(index, 1);
	}
	
	return updateObject( state, {
        modules: [ ...modules ]
    });
}

const setLimit = (state, action, type) => {
    let limits = { ...state.limits };
    limits[type] = action.obj;
    return updateObject( state, {
        limits: limits
    });
}

const setAppKeys = (state, action) => {
    return updateObject(state, { keys: action.obj.keys });
}

const reducer = ( state = initialState, action) => {
    switch (action.type) {
        case actionTypes.INIT_START: return initStart(state, action);
        case actionTypes.INIT_SUCCESS: return initSuccess(state, action);
        case actionTypes.INIT_FAIL: return initFail(state, action);
        case actionTypes.APP_ERROR: return appError(state, action);
        case actionTypes.APP_ADD_MESSAGE: return addMessage(state, action);
        case actionTypes.APP_REMOVE_DIALOG: return updateObject(state, { dialog: null});
        case actionTypes.APP_MODULES_LOAD_SUCCESS: 
            return updateObject(state, { modules: action.modules });
        case actionTypes.APP_MODULES_INIT: 
            return initModules(state, action);
        case actionTypes.APP_LIMIT_CLIP: 
            return setLimit(state, action, Limit.OBJECT_TYPE_CLIP);
        case actionTypes.APP_LIMIT_USER: 
            return setLimit(state, action, Limit.OBJECT_TYPE_USER);
        case actionTypes.APP_LIMIT_ROOM: 
            return setLimit(state, action, Limit.OBJECT_TYPE_ROOM);
        case actionTypes.APP_GET_KEYS: 
            return updateObject(state, { keys: action.obj.keys });
        case actionTypes.APP_ADD_KEY: 
            return updateObject(state, { keys: action.obj.keys });
        case actionTypes.APP_REMOVE_KEY: 
            return updateObject(state, { keys: action.obj.keys });
        case actionTypes.APP_GET_PRODUCTS: 
            return updateObject(state, { products: action.obj.products });
		case actionTypes.APP_MODULE_SUCCESS: return moduleSuccess(state, action);
		case actionTypes.APP_MODULE_ERROR: return moduleError(state, action);
        case actionTypes.APP_GET_VERSION_SUCCESS: 
            return updateObject(state, { version: action.res });
        default: 
            return state;
    }
}

export default reducer;
